module.exports = __webpack_public_path__ + "assets/svg/Icons/32/date-blue-16c0b0.svg";